module.exports = __webpack_public_path__ + "img/belgium.de94eb74.png";